﻿export interface IHlaData {
    hlaA1: number;
    hlaA1HighRes: string; // A1_detail - data from Histo
    hlaA2: number;
    hlaA2HighRes: string;
    hlaB1: number;
    hlaB1HighRes: string; 
    hlaB2: number;
    hlaB2HighRes: string;
    hlaDr1: number;
    hlaDr1HighRes: string;
    hlaDr2: number;
    hlaDr2HighRes: string;
    hlaBw1: number;
    hlaBw1HighRes: string;
    hlaBw2: number;
    hlaBw2HighRes: string;
    hlaCw1: number;
    hlaCw1HighRes: string;
    hlaCw2: number;
    hlaCw2HighRes: string;
    hlaDq1: number;
    hlaDq1HighRes: string;
    hlaDq2: number;
    hlaDq2HighRes: string;
    hlaDqa1: number;
    hlaDqa1HighRes: string;
    hlaDqa2: number;
    hlaDqa2HighRes: string;
    hlaDp1: number;
    hlaDp1HighRes: string;
    hlaDp2: number;
    hlaDp2HighRes: string;
    hlaDpa1: number;
    hlaDpa1HighRes: string;
    hlaDpa2: number;
    hlaDpa2HighRes: string;
    hladRw3: number;
    hlaDr51: boolean;
    hlaDr51HighRes: string;
    hlaDr51HighRes2: string;
    hlaDr52: boolean;
    hlaDr52HighRes: string;
    hlaDr52HighRes2: string;
    hlaDr53: boolean;
    hlaDr53HighRes: string;
    hlaDr53HighRes2: string;
}
